import { HttpResponseError } from '@vista-digital/http-client';
import { FutureRecurringMemberSubscriptionCreationStatus } from '@vista-digital/ocapi-types/v1';
export const futureRecurringMemberSubscriptionCreationPollingPredicate = async (response) => {
    if (!response.ok)
        return handleBadResponse(response);
    // No need to poll, there is no in-progress future recurring subscription creation
    if (response.status === 204)
        return true;
    const creation = await response.clone().json();
    return creation.status !== FutureRecurringMemberSubscriptionCreationStatus.Pending;
};
export const futureRecurringMemberSubscriptionCreationPollingConfiguration = {
    predicate: futureRecurringMemberSubscriptionCreationPollingPredicate,
    exponentialWaitTime: true
};
const handleBadResponse = (response) => {
    const error = new HttpResponseError(response);
    if (!error.isTransient)
        throw error; // No need to poll, cannot be retried.
    return false; // Return false to allow polling to continue.
};
//# sourceMappingURL=future-recurring-member-subscription-creation-polling-predicate.js.map